export default {
  // Navigation
  "nav": {
    "home": "Accueil",
    "pedagogy": "Pédagogie",
    "events": "Événements",
    "blog": "Blog",
    "registration": "Inscription",
    "about": "À propos",
    "contact": "Contact",
    "login": "Connexion",
    "logout": "Déconnexion",
    "dashboard": "Tableau de bord"
  },
  
  // Page de connexion
  "login": {
    "title": "Connexion",
    "email": "Email",
    "password": "Mot de passe",
    "signIn": "Se connecter",
    "signingIn": "Connexion en cours...",
    "error": "Erreur de connexion",
    "invalidCredentials": "Email ou mot de passe incorrect"
  },
  // Page d'accueil
  "home": {
    "hero": {
      "title": "Dispositif Nouvelle Chance",
      "subtitle": "Un accompagnement complet pour les jeunes NEETs",
      "cta": "Découvrir notre programme"
    },
    "faq": {
      "title": "Vous avez des questions ?",
      "description": "Cliquez sur une question pour obtenir une réponse instantanée de notre assistant virtuel.",
      "questionsTitle": "Questions fréquentes",
      "chatTitle": "Assistant DNC",
      "chatWelcome": "Bonjour ! Je suis l'assistant virtuel de DNC. Comment puis-je vous aider aujourd'hui ?",
      "chatPlaceholder": "Tapez votre question ici...",
      "questions": {
        
      },
      "answers": {
        },
      "keywords": {
        "start": "commencer",
        "accompany": "accompagné",
        "internship": "stage"
      },
      "responses": {
        "start": "Pour commencer avec le DNC, je vous recommande de consulter notre page d'inscription et de remplir le formulaire de candidature. Vous pouvez également visiter notre page 'Pédagogie' pour en savoir plus sur nos programmes de formation.",
        "accompany": "Notre programme d'accompagnement personnalisé vous aide à développer vos compétences et à atteindre vos objectifs professionnels. Chaque participant bénéficie d'un mentor dédié qui le guide tout au long du parcours.",
        "internship": "Le DNC propose des stages pratiques dans divers secteurs professionnels grâce à nos partenariats avec des entreprises locales et internationales. Ces stages vous permettent d'appliquer vos connaissances et de gagner une expérience précieuse.",
        "default": "Merci pour votre question. Le DNC est là pour vous aider dans votre parcours professionnel. N'hésitez pas à nous contacter directement pour des informations plus spécifiques ou à explorer notre site web pour en savoir plus sur nos programmes."
      }
    },
    "stats": {
      "title": "Notre impact en chiffres",
      "students": "Jeunes formés",
      "partners": "Partenaires",
      "successRate": "Taux de réussite",
      "coursesCompleted": "Formations complétées"
    },
    "about": {
      "title": "À propos du DNC",
      "description": "Le Dispositif National Nouvelle Chance (DNC) est un programme d'accompagnement intensif de 6 mois pour les jeunes NEETs (ni en emploi, ni en études, ni en formation). Notre objectif est de fournir les compétences nécessaires pour une intégration professionnelle réussie."
    },
    "whoAreYou": {
      "title": "Qui êtes-vous ?",
      "subtitle": "Sélectionnez votre profil pour découvrir le contenu qui vous correspond",
      "young": {
        "title": "Jeune",
        "description": "Découvrez nos formations et inscrivez-vous",
        "cta": "S'inscrire"
      },
      "parent": {
        "title": "Parent",
        "description": "Découvrez notre pédagogie et nos valeurs",
        "cta": "En savoir plus"
      },
      "partner": {
        "title": "Partenaire",
        "description": "Collaborez avec nous et participez à notre mission",
        "cta": "Nous connaître"
      }
    },
    "testimonials": {
      "title": "Ils témoignent",
      "viewAll": "Voir tous les témoignages"
    },
    "features": {
      "feature1": {
        "title": "Formation Personnalisée",
        "description": "Des parcours adaptés à vos besoins et objectifs professionnels."
      },
      "feature2": {
        "title": "Accompagnement",
        "description": "Un suivi individualisé par nos conseillers experts."
      },
      "feature3": {
        "title": "Insertion Professionnelle",
        "description": "Des opportunités réelles de stages et d'emplois avec nos partenaires."
      }
    },
    "faq": {
      "title": "Vous avez des questions ?",
      "description": "Cliquez sur une question pour obtenir une réponse instantanée de notre assistant virtuel.",
      "questionsTitle": "Questions fréquentes",
      "questions": {
        "q0": "Comment je peux participer au DNC ?",
        "q1": "Vous ne savez pas par où commencer ?",
        "q2": "Souhaitez-vous être accompagné dans votre parcours ?",
        "q3": "Voulez-vous vivre l'expérience et faire des stages dans votre domaine de prédilection ?",
        "q4": "C'est quoi le DNC ?",
        "q5": "Comment faire l'inscription au DNC ?",
        "q6": "Combien de jours je vais être présent au DNC ?",
        "q7": "Qu'est-ce que je vais apprendre au DNC ?",
        "q8": "Est ce que la formation au DNC est payante ou gratuite ?"
      },
      "answers": {
        "a0": "Si vous êtes entre 18 et 30 ans, sans diplôme et sans emploi, et que vous cherchez une orientation professionnelle, vous pouvez participer au DNC en remplissant le formulaire de candidature disponible sur notre site web. Une fois votre candidature soumise, notre équipe examinera votre dossier et vous contactera pour la suite du processus.",
        "a1": "Le Dispositif National Nouvelle Chance est un projet pilote à Sousse et à Kairouan visant à renforcer l'employabilité et à autonomiser les jeunes tunisiens NEET (ni en études, ni en emploi, ni en formation) par l'accompagnement personnalisé, le mentorat et des opportunités pratiques.",
        "a2": "Absolument ! Notre programme comprend un accompagnement personnalisé tout au long de votre parcours. Nos mentors vous guideront à chaque étape pour vous aider à atteindre vos objectifs.",
        "a3": "Oui, le DNC offre des opportunités de stages pratiques dans divers domaines professionnels. Nos partenariats avec des entreprises vous permettent d'acquérir une expérience concrète dans votre domaine d'intérêt.",
        "a4": "Le Dispositif National Nouvelle Chance (DNC) est un projet pilote à Sousse et à Kairouan visant à autonomiser les jeunes NEET (ni en études, ni en emploi, ni en formation) par l'accompagnement, le mentorat et des opportunités pratiques. Notre programme aide ces jeunes à renforcer leurs compétences pour mieux s'intégrer dans le marché du travail et développer leur employabilité.",
        "a5": "Pour vous inscrire au DNC, vous pouvez vous rendre sur la page d'inscription de notre site web, remplir le formulaire avec vos informations personnelles, puis soumettre votre candidature. Notre équipe examinera votre dossier et vous contactera pour la suite du processus.",
        "a6": "La durée de présence au DNC est de 6 mois, avec des séances régulières par semaine du lundi au vendredi de 9h à 14h et la présence est obligatoire. Le calendrier précis vous sera communiqué après votre admission.",
        "a7": "Au DNC, vous allez acquérir des compétences spécifiques à votre domaine d'intérêt, des compétences transversales (communication, français, compétences numériques, compétences de vie, calcul et raisonnement), ainsi que des compétences en technique de recherche d'emploi. Vous bénéficierez également d'un accompagnement personnalisé et de stages pratiques.",
        "a8": "Vous bénéficiez d’un accompagnement totalement gratuit. En plus, grâce à notre partenariat avec les bureaux d’emploi, vous pouvez bénéficier d’une bourse de 150DT par mois tout au long de votre parcours afin de vous permettre de couvrir vos frais de transport."
       },
      "keywords": {
        "start": "commencer",
        "accompany": "accompagné",
        "internship": "stage"
      },
      "responses": {
        "start": "Vous pouvez commencer par vous inscrire à notre programme via la page d'inscription. Notre équipe vous contactera et vous guidera tout au long du processus.",
        "accompany": "Oui, nous offrons un accompagnement personnalisé à chaque participant. Vous aurez un mentor dédié pour vous aider à développer vos compétences et atteindre vos objectifs.",
        "internship": "Absolument ! Notre programme comprend une période de stage pratique dans des entreprises partenaires. C'est une excellente opportunité pour acquérir une expérience pratique dans votre domaine d'intérêt.",
        "default": "Merci pour votre question. Le programme DNC est une initiative visant à soutenir les jeunes en Tunisie à travers la formation, le mentorat et des opportunités pratiques. Puis-je vous aider avec des informations plus spécifiques ?"
      },
      "chatTitle": "Assistant DNC",
      "chatWelcome": "Bonjour ! Je suis l'assistant virtuel de DNC. Comment puis-je vous aider aujourd'hui ?",
      "chatPlaceholder": "Tapez votre question ici..."
    }
  },
  // Section Moments Capturés
  "capturedMoments": {
    "title": "Moments Capturés",
    "subtitle": "Découvrez en images les moments forts de nos événements et activités",
    "viewEvents": "Voir nos événements"
  },
  // Page pédagogie
  "pedagogy": {
    "hero": {
      "title": "Notre Pédagogie",
      "description": "Un programme d'accompagnement de 6 mois qui aide les jeunes à trouver leur voie et construire leur avenir professionnel."
    },
    "intro": {
      "title": "Notre Approche Pédagogique",
      "subtitle": "Un programme d'accompagnement innovant pour les jeunes NEETs",
      "cardTitle": "Un parcours personnalisé",
      "cardText": "Notre programme est un projet pilote à Sousse et à Kairouan conçu pour renforcer les compétences et développer l'employabilité des jeunes NEET.",
      "highlight": "Un parcours personnalisé pour chaque jeune, adapté à ses besoins et à son projet professionnel."
    },
    "activeMethod": {
      "title": "La Pédagogie Active",
      "subtitle": "Une approche innovante centrée sur l'apprenant",
      "description": "La pédagogie active place le jeune au centre de son apprentissage, favorisant l'autonomie et l'engagement par l'expérimentation et la pratique.",
      "comparison": {
        "title": "Pédagogie Active vs Traditionnelle",
        "traditional": "Pédagogie Traditionnelle",
        "active": "Pédagogie Active",
        "item1": {
          "traditional": "Centrée sur l'enseignant",
          "active": "Centrée sur l'apprenant"
        },
        "item2": {
          "traditional": "Transmission passive du savoir",
          "active": "Apprentissage par l'expérience"
        },
        "item3": {
          "traditional": "Évaluation standardisée",
          "active": "Évaluation continue et personnalisée"
        },
        "item4": {
          "traditional": "Environnement formel et rigide",
          "active": "Environnement flexible et collaboratif"
        },
        "item5": {
          "traditional": "Accent sur la mémorisation",
          "active": "Accent sur la résolution de problèmes"
        }
      },
      "benefits": {
        "title": "Avantages pour les jeunes NEET",
        "item1": {
          "title": "Motivation accrue",
          "description": "Les apprenants sont plus engagés car ils participent activement à leur apprentissage"
        },
        "item2": {
          "title": "Développement de l'autonomie",
          "description": "Apprentissage de la prise d'initiative et de la responsabilité"
        },
        "item3": {
          "title": "Compétences pratiques",
          "description": "Acquisition de compétences directement applicables dans le monde professionnel"
        },
        "item4": {
          "title": "Confiance en soi",
          "description": "Renforcement de l'estime de soi à travers des succès concrets"
        }
      }
    },
    "axes": {
      "title": "Les 5 Axes d'Accompagnement",
      "subtitle": "Notre programme est structuré autour de 5 axes complémentaires pour un développement global",
      "tableHeader": "Détails de l'accompagnement",
      "axis1": {
        "title": "Accompagnement psychologique",
        "description": "Soutien pour mieux gérer ses émotions et renforcer la confiance en soi.",
        "details": [
          "Séances individuelles avec un psychologue",
          "Ateliers de gestion du stress",
          "Développement de l'estime de soi",
          "Techniques de relaxation et de bien-être"
        ]
      },
      "axis2": {
        "title": "Compétences de vie",
        "description": "Développement des soft skills pour s'intégrer dans la société et dans le monde du travail.",
        "details": [
          "Communication interpersonnelle",
          "Travail en équipe",
          "Résolution de problèmes",
          "Gestion du temps",
          "Prise de décision"
        ]
      },
      "axis3": {
        "title": "Compétences clés",
        "description": "Renforcement des compétences fondamentales nécessaires pour réussir.",
        "details": [
          "Calcul et raisonnement logique",
          "Communication écrite et orale",
          "Langues étrangères",
          "Compétences numériques",
          "Littératie et culture générale"
        ]
      },
      "axis4": {
        "title": "Acteur de ma vie, acteur de ma ville",
        "description": "Sensibilisation et engagement à travers des événements et des actions citoyennes.",
        "details": [
          "Projets communautaires",
          "Sensibilisation à l'environnement",
          "Participation à des événements culturels",
          "Actions de solidarité",
          "Découverte du patrimoine local"
        ]
      },
      "axis5": {
        "title": "Accompagnement professionnel",
        "description": "Techniques de recherche d'emploi, rédaction de CV, stages et attitude professionnelle.",
        "details": [
          "Rédaction de CV et lettre de motivation",
          "Techniques d'entretien d'embauche",
          "Recherche de stage et d'emploi",
          "Développement d'un réseau professionnel",
          "Immersion en entreprise"
        ]
      }
    },
    "journey": {
      "title": "Le Parcours en 4 Étapes",
      "subtitle": "Un parcours structuré pour maximiser vos chances de réussite",
      "step1": {
        "title": "Intégration",
        "description": "Découverte du dispositif, bilan personnel et projet initial.",
        "details": [
          "Accueil et présentation du programme",
          "Évaluation des compétences initiales",
          "Définition des objectifs personnels",
          "Établissement du plan d'accompagnement"
        ]
      },
      "step2": {
        "title": "Construction",
        "description": "Développement des compétences et immersion en entreprise.",
        "details": [
          "Ateliers de développement des compétences",
          "Stages d'observation en entreprise",
          "Projets collectifs",
          "Suivi régulier avec les référents", 
          "Construction d'un projet professionnel"
        ]
      },
      "step3": {
        "title": "Validation",
        "description": "Finalisation du projet professionnel et préparation à l'insertion.",
        "details": [
          "Stage d'application en entreprise",
          "Validation des acquis",
          "Finalisation du projet professionnel",
          "Préparation à la sortie du dispositif",
          "Élaboration d'un plan d'action pour la prochaine période",
          "Pitch et présentation de son parcours"
        ]
      },
      "step4": {
        "title": "Post-Parcours",
        "description": "Suivi et maintien de la motivation après le programme.",
        "details": [
          "Suivi  6 mois après la sortie",
          "Aide à la recherche d'emploi ou de formation",
          "Contacts réguliers avec le référent",
          "Accès aux ressources et au réseau DNC",
          "Suivi du plan d'action élaboré"
        ]
      }
    },
    "roles": {
      "title": "Les Rôles Clés dans l'Accompagnement",
      "subtitle": "Une équipe pluridisciplinaire dédiée à votre réussite",
      "role1": {
        "title": "Coach Référent",
        "description": "Votre interlocuteur principal tout au long du parcours.",
        "details": [
          "Suivi personnalisé et régulier",
          "Animation des séances",
          "Coordination de votre parcours",
          "Adaptation du programme selon vos besoins",
          "Point de contact principal"
        ]
      },
      "role2": {
        "title": "Coach Entreprise",
        "description": "Facilite votre intégration dans le monde professionnel.",
        "details": [
          "Recherche de stages et d'opportunités",
          "Animation des séances de TRE",
          "Préparation aux entretiens",
          "Médiation avec les entreprises",
          "Suivi pendant les périodes d'immersion"
        ]
      },
      "role3": {
        "title": "Conseiller Psycho-Social",
        "description": "Vous aide à surmonter les obstacles personnels.",
        "details": [
          "Soutien émotionnel et psychologique",
          "Aide à la résolution de problèmes personnels",
          "Développement de la confiance en soi",
          "Orientation vers des services spécialisés si nécessaire"
        ]
      },
      "role4": {
        "title": "Chargé de Coordination des Projets",
        "description": "Organise les activités collectives et les projets.",
        "details": [
          "Conception et animation d'ateliers",
          "Organisation d'événements",
          "Coordination des projets collectifs",
          "Développement de partenariats"
        ]
      }
    },
    "skills": {
      "title": "Les Compétences Essentielles",
      "subtitle": "À la fin du parcours, vous aurez développé ces trois compétences fondamentales",
      "skill1": {
        "title": "Autonomie",
        "description": "Capacité à prendre des initiatives, à s'organiser et à agir de manière indépendante dans sa vie personnelle et professionnelle."
      },
      "skill2": {
        "title": "Insertion Sociale",
        "description": "Aptitude à s'intégrer dans différents environnements sociaux, à communiquer efficacement et à travailler en équipe."
      },
      "skill3": {
        "title": "Construction de Projet de Vie",
        "description": "Capacité à définir ses objectifs, à planifier les étapes pour les atteindre et à s'adapter aux changements."
      }
    },
    "cta": {
      "title": "Prêt à construire votre avenir ?",
      "text": "Rejoignez le Dispositif National Nouvelle Chance et bénéficiez d'un accompagnement personnalisé pour réussir votre insertion professionnelle.",
      "button": "Rejoindre le programme"
    }
  },
  // Page événements
  "events": {
    "upcoming": "À venir",
    "past": "Passés",
    "title": "Nos Événements",
    "subtitle": "Découvrez nos événements passés et à venir",
    "upcomingEvents": "Événements à venir",
    "pastEvents": "Événements passés",
    "pastEvent": "Événement passé",
    "viewDetails": "Voir les détails",
    "closeDetails": "Fermer",
    "addEvent": "Ajouter un événement",
    "noEvents": "Aucun événement trouvé",
    "date": "Date",
    "time": "Heure",
    "location": "Lieu",
    "category": "Catégorie",
    "status": "Statut",
    "gallery": "Galerie photo",
    "outcomes": "Résultats et impact",
    "description": "Description",
    "eventInfo": "Informations sur l'événement",
    "backToEvents": "Retour aux événements",
    "share": "Partager",
    "tags": {
      "health": "Santé",
      "culture": "Culture",
      "sports": "Sport",
      "professional": "Professionnel"
    },
    "categories": {
      "workshop": "Atelier",
      "conference": "Conférence",
      "seminar": "Séminaire",
      "training": "Formation",
      "meeting": "Réunion",
      "other": "Autre"
    },
    "filters": {
      "title": "Filtrer les événements",
      "all": "Tous",
      "upcoming": "À venir",
      "past": "Passés",
      "workshop": "Atelier",
      "seminar": "Séminaire",
      "conference": "Conférence",
      "health": "Santé",
      "culture": "Culture",
      "sports": "Sportif",
      "professional": "Professionnel",
      "internal": "Interne",
      "training": "Formation",
      "external": "Externe"
    },
    "form": {
      "title": "Titre",
      "description": "Description",
      "date": "Date",
      "time": "Heure",
      "location": "Lieu",
      "category": "Catégorie",
      "type": "Type",
      "status": "Statut",
      "mainImage": "Image principale",
      "gallery": "Galerie photo",
      "outcomes": "Résultats",
      "imageUrl": "URL de l'image",
      "addImage": "Ajouter une image",
      "addOutcome": "Ajouter un résultat",
      "outcomeExample": "Ex: 50 participants ont assisté à l'événement",
      "selectCategory": "Sélectionner une catégorie",
      "selectType": "Sélectionner un type",
      "selectStatus": "Sélectionner un statut",
      "submit": "Soumettre",
      "cancel": "Annuler",
      "health": "Santé",
      "culture": "Culture",
      "sports": "Sportif",
      "professional": "Professionnel",
      "internal": "Interne",
      "training": "Formation",
      "external": "Externe"
    },
    "closeForm": "Fermer le formulaire"
  },
  // Page inscription
  "registration": {
    "title": "Inscription au programme",
    "subtitle": "Rejoignez le Dispositif National Nouvelle Chance",
    "info": "Le DNC est ouvert aux jeunes de 18 à 29 ans, sans emploi et sans formation en cours.",
    "form": {
      "personalInfo": "Informations personnelles",
      "firstName": "Prénom",
      "lastName": "Nom",
      "dob": "Date de naissance",
      "gender": "Genre",
      "male": "Masculin",
      "female": "Féminin",
      "other": "Autre",
      "contactInfo": "Coordonnées",
      "email": "Email",
      "phone": "Téléphone",
      "address": "Adresse",
      "city": "Ville",
      "education": "Formation",
      "highestDegree": "Diplôme le plus élevé",
      "schoolName": "Nom de l'établissement",
      "graduationYear": "Année d'obtention",
      "motivation": "Motivation",
      "motivationText": "Pourquoi souhaitez-vous rejoindre le DNC?",
      "expectations": "Qu'attendez-vous de ce programme?",
      "hearAboutUs": "Comment avez-vous entendu parler de nous?",
      "submit": "Soumettre ma candidature",
      "required": "Champ obligatoire",
      "success": "Votre candidature a été soumise avec succès!",
      "error": "Une erreur s'est produite. Veuillez réessayer."
    }
  },
  // Page à propos
  "about": {
    "hero": {
      "title": "À propos du DNC",
      "subtitle": "Notre mission, notre équipe et nos partenaires"
    },
    "values": {
      "title": "Nos Valeurs",
      "subtitle": "Les principes qui guident notre action",
      "values": [
        {
          "title": "Excellence",
          "description": "Nous visons l'excellence dans tous nos programmes et services.",
          "icon": "FaAward"
        },
        {
          "title": "Inclusion",
          "description": "Nous croyons en l'égalité des chances pour tous les jeunes.",
          "icon": "FaUsers"
        },
        {
          "title": "Innovation",
          "description": "Nous adoptons des approches innovantes pour résoudre les défis.",
          "icon": "FaLightbulb"
        },
        {
          "title": "Engagement",
          "description": "Nous sommes engagés envers la réussite de chaque participant.",
          "icon": "FaHandshake"
        }
      ]
    },
    "iecd": {
      "title": "L'IECD",
      "subtitle": "Institut Européen de Coopération et de Développement",
      "description": "L'IECD est une organisation de solidarité internationale créée en 1988 qui met en œuvre des projets de développement économique et humain dans 18 pays, avec une attention particulière portée à la formation et à l'insertion professionnelle des jeunes.",
      "stats": {
        "countries": "PAYS",
        "beneficiaries": "BÉNÉFICIAIRES",
        "projects": "PROJETS"
      },
      "mission": {
        "title": "MISSION",
        "description": "Bâtir des environnements permettant à toute personne de construire son avenir et une société plus juste."
      },
      "domains": {
        "title": "3 DOMAINES D'INTERVENTION",
        "training": "FORMATION ET INSERTION PROFESSIONNELLE",
        "entrepreneurship": "ENTREPRENEURIAT",
        "education": "ÉDUCATION"
      },
      "tunisia": {
        "title": "L'IECD EN TUNISIE",
        "since": "Implanté depuis",
        "inCountry": "dans le pays",
        "expectedBeneficiaries": "bénéficiaires attendus",
        "projects": "projets",
        "localPartners": "partenaires opérationnels locaux",
        "businessPartners": "partenaires entreprises et OSC",
        "trainingCenters": "centres de formation"
      }
    },
    "dnc": {
      "title": "Dispositif Nouvelle Chance",
      "subtitle": "Un programme d'insertion socio-professionnelle pour les jeunes",
      "description": "Le Dispositif National Nouvelle Chance (DNC) est un programme qui vise à favoriser l'insertion socio-professionnelle des jeunes en situation de vulnérabilité en Tunisie, en leur offrant un parcours complet de formation et d'accompagnement.",
      "objective": {
        "title": "Objectif",
        "content": "Accompagner les jeunes NEETs (ni en emploi, ni en études, ni en formation) âgés de 18 à 30 ans vers l'insertion professionnelle à travers un parcours personnalisé."
      },
      "context": {
        "title": "Contexte",
        "unemployment": "Taux de chômage des jeunes : 35.4%",
        "neets": "~ 31.8% des jeunes sont des NEETs",
        "women": "Taux de chômage des jeunes femmes : 38.7%",
        "source": "Source : Organisation Internationale du Travail (OIT)"
      },
      "framework": {
        "title": "Cadre du projet",
        "steps": {
          "step1": {
            "title": "ANALYSE DU PROJET",
            "date": "2022"
          },
          "step2": {
            "title": "PREMIER GROUPE DE TEST",
            "date": "Mars 2024"
          },
          "step3": {
            "title": "INAUGURATION DNC SOUSSE",
            "date": "20 Août 2024"
          },
          "step4": {
            "title": "INAUGURATION DNC KAIROUAN",
            "date": "6 Décembre 2024"
          }
        }
      },
      "details": {
        "title": "DISPOSITIF NATIONAL NOUVELLE CHANCE - SOUSSE ET KAIROUAN",
        "duration": "Durée du projet : 2024 - 2027",
        "period": "Sur la période 2024 - 2027",
        "beneficiaries": "1000 jeunes NEETs âgés de 18 à 30 ans (dont 40% de femmes) accompagnés :",
        "locations": "Bureaux de l'Emploi et du Travail Indépendant (BETI) et Maisons des Jeunes de Sousse et Kairouan",
        "professionals": "30 professionnels des Bureaux de l'Emploi et du travail Indépendant (BETI) et des Maisons des jeunes de Sousse et Kairouan renforcés et formés à l'approche \"nouvelle chance\"",
        "approach": "Accompagnement personnalisé des jeunes dans la définition du projet professionnel",
        "training": "Formations continues des acteurs de jeunesses sur les pratiques pédagogiques d'accompagnement et d'orientation professionnelle",
        "impact": {
          "title": "Impact attendu :",
          "rate": ">50% trouvent un emploi, poursuivent une formation, ou entament une activité entrepreneuriale",
          "perspectives": "Perspectives 2024 :",
          "activities": "Déploiement des activités, 200 jeunes accueillis",
          "network": "Développement du réseau entreprises",
          "government": "Déploiement du dispositif auprès de l'état tunisien"
        }
      },
      "summary": {
        "title": "DISPOSITIF NATIONAL NOUVELLE CHANCE",
        "duration": "4 ans",
        "duration_period": "Mai 2024 - Mai 2027",
        "centers": "2 DNC",
        "centers_locations": "SOUSSE KAIROUAN",
        "beneficiaries": "1000",
        "beneficiaries_details": "JEUNES NEETs 18-30 ans"
      }
    },
    "history": {
      "title": "Notre histoire",
      "subtitle": "Les étapes clés de notre développement",
      "milestone1": {
        "year": "2022",
        "content": "ANALYSE DU PROJET"
      },
      "milestone2": {
        "year": "Mars 2024",
        "content": "PREMIER GROUPE DE TEST"
      },
      "milestone3": {
        "year": "20 Août 2024",
        "content": "INAUGURATION DNC SOUSSE"
      },
      "milestone4": {
        "year": "6 Décembre 2024",
        "content": "INAUGURATION DNC KAIROUAN"
      }
    },
    "team": {
      "title": "Notre équipe",
      "subtitle": "Les personnes qui dirigent notre mission",
      "categories": {
        "all": "Tous",
        "management": "Management",
        "coach": "Coachs",
        "pedagogique": "Pédagogique",
        "entreprise": "Entreprise",
        "psycho": "Psycho-sociale",
        "administration": "Administration",
        "communication": "Communication"
      },
      "members": [
        {
          "name": "Ouafa Fathalah",
          "role": "Responsable DNC",
          "description": "Gestion globale du projet DNC et coordination des équipes.",
          "image": "/image/apropos/equipe/ouafa.jpg",
          "category": "management"
        },
        {
          "name": "Asma Mrad",
          "role": "Coordinatrice pédagogique",
          "description": "Supervision des programmes de formation et accompagnement des bénéficiaires.",
          "image": "/image/apropos/equipe/asma.jpg",
          "category": "pedagogique"
        },
         {
          "name": "Zeineb Cheniore",
          "role": "Coordinatrice entreprise et partenariat",
          "description": "Gestion des partenariats et relations avec les entreprises.",
          "image": "/image/apropos/equipe/zeineb.jpg",
          "category": "entreprise"
        },
        {
          "name": "Ahmed Abidi",
          "role": "Chargé des coordination des projets",
          "description": "Coordination des projets et suivi des activités.",
          "image": "/image/apropos/equipe/ahmed.jpg",
          "category": "pedagogique"
              },
              {
                "name": "Rania Akrout",
                "role": "Conseillère psycho-sociale",
                "description": "Soutien psychologique et accompagnement des bénéficiaires.",
                "image": "/image/apropos/equipe/rania.jpg",
                "category": "psycho"
              },
              {
                "name": "Nour Nasraoui",
                "role": "Chargée du projet",
                "description": "Gestion administrative et suivi des activités.",
                "image": "/image/apropos/equipe/nour.jpg",
                "category": "administration"
              },
              {
                "name": "Ahmed Ben Larbi",
                "role": "Coach référent",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/ahmedbl.jpg",
                "category": "coach"
              },
              {
                "name": "Ichraf Barhoumi",
                "role": "Coach référente",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/ichraf.jpg",
                "category": "coach"
              },
              {
                "name": "Nidhal Frajd",
                "role": "Coach référent",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/nidhal.jpg",
                "category": "coach"
              },
              {
                "name": "Taher Garouachi",
                "role": "Coach référent",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/taher.jpg",
                "category": "coach"
              },
              {
                "name": "Emna Ben Saad",
                "role": "Coach référente",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/emna.jpg",
                "category": "coach"
              },
              {
                "name": "Rim Haouari",
                "role": "Coach référente",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/rim.jpg",
                "category": "coach"
              },
              {
                "name": "Salah Dhahri",
                "role": "Coach référent",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/salah.jpg",
                "category": "coach"
              },
              {
                "name": "Feryel Rezgueni",
                "role": "Coach référente",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/feryel.jpg",
                "category": "coach"
              },
              {
                "name": "Imen Hajji",
                "role": "Coach référente",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/imen.jpg",
                "category": "coach"
              },
              {
                "name": "Mariem Chaieb",
                "role": "Coach référente",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/mariem.jpg",
                "category": "coach"
              },
              {
                "name": "Mohamed Taher Sdiri",
                "role": "Coach référent",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/mohamed.jpg",
                "category": "coach"
              },
              {
                "name": "Oumayma Ben Kalia",
                "role": "Coach référente",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/oumayma.jpg",
                "category": "coach"
              },
              {
                "name": "Majdi Hasnaoui",
                "role": "Agent polyvalent",
                "description": "Support administratif et logistique.",
                "image": "/image/apropos/equipe/majdi.jpg",
                "category": "administration"
              },
              {
                "name": "Fares Hbib Bouallegue",
                "role": "Responsable Administratif et Financier",
                "description": "Gestion administrative et financière du projet.",
                "image": "/image/apropos/equipe/fares.jpg",
                "category": "administration"
              },
              {
                "name": "Anaguim Zanina",
                "role": "Assistante Administrative",
                "description": "Support administratif et gestion des documents.",
                "image": "/image/apropos/equipe/anaguim.jpg",
                "category": "administration"
              },
              {
                "name": "Xavier Bresnu",
                "role": "Responsable des opérations Tunisie",
                "description": "Supervision des opérations en Tunisie et coordination locale.",
                "image": "/image/apropos/equipe/xavier.jpg",
                "category": "management"
              },
              {
                "name": "Maysson Baneni",
                "role": "Coach entreprise",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/maysson.jpg",
                "category": "entreprise"
              },
              {
                "name": "Mohamed Amine Selmi",
                "role": "Coach entreprise",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/mohameds.jpg",
                "category": "entreprise"
              },
              {
                "name": "Amine Khalfaoui",
                "role": "Coach entreprise",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/amine.jpg",
                "category": "entreprise"
              },
              {
                "name": "Sameh Ben Hassen",
                "role": "Coach entreprise",
                "description": "Accompagnement professionnel et développement des compétences.",
                "image": "/image/apropos/equipe/sameh.jpg",
                "category": "entreprise"
              },
              {
                "name": "Zied Hannachi",
                "role": "Coordinateur de la communication et des événements",
                "description": "Gestion de la communication et organisation des événements.",
                "image": "/image/apropos/equipe/zied.jpg",
                "category": "communication"
              },
              {
                "name": "Fatma Mneni ",
                "role": "Chargée de site Kairouan",
                "description": "Gestion du site de Kairouan et coordination locale.",
                "image": "/image/apropos/equipe/fatma.jpg",
                "category": "management"
              },
              
              {
                "name": "Baher Ouani ",
                "role": "assitant administratif",
                "description": "assitance administratif et gestion des documents",
                "image": "/image/apropos/equipe/baher.jpg",
                "category": "administration"
              }
            ]
    },
    "partners": {
      "title": "Nos Partenaires",
      "subtitle": "Ils nous font confiance et nous soutiennent",
      "description": "Nous travaillons en étroite collaboration avec des partenaires institutionnels, des entreprises et des organisations de la société civile pour maximiser notre impact.",
      "categories": {
        "all": "Tous",
        "institutional": "Institutionnels",
        "enterprises": "Entreprises",
        "ngos": "Associations"
      },
      "becomePartner": "Devenir partenaire",
      "partnersList": {
        "afd": "Partenaire institutionnel",
        "mefp": "Partenaire institutionnel",
        "aneti": "Partenaire institutionnel",
        "atfp": "Partenaire institutionnel",
        "lrb": "Partenaire entreprise",
        "slehAyed": "Partenaire entreprise",
        "sancella": "Partenaire entreprise",
        "plastika": "Partenaire entreprise",
        "kmc": "Partenaire entreprise",
        "nakcha": "Partenaire entreprise",
        "kidsLand": "Partenaire entreprise",
        "continental": "Partenaire entreprise",
        "gymClub": "Partenaire entreprise",
        "eurocycles": "Partenaire entreprise",
        "gfi": "Partenaire entreprise",
        "billionnaire": "Partenaire entreprise",
        "mellouli": "Partenaire entreprise",
        "essoukri": "Partenaire entreprise",
        "amt": "Partenaire entreprise",
        "elMouradi": "Partenaire entreprise",
        "decathlon": "Partenaire entreprise",
        "mg": "Partenaire entreprise",
        "rfiki": "Partenaire association",
        "ftartchy": "Partenaire association",
        "awledna": "Partenaire association"
      }
    },
  
  // Admin
  "admin": {
    "dashboard": "Tableau de bord",
    "applications": "Candidatures",
    "events": "Gestion des événements",
    "content": "Gestion du contenu",
    "users": "Utilisateurs",
    "settings": "Paramètres",
    "stats": "Statistiques",
    "logout": "Déconnexion",
    "login": {
      "title": "Espace Administrateur",
      "subtitle": "Connectez-vous pour accéder au tableau de bord",
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "rememberMe": "Se souvenir de moi",
      "forgotPassword": "Mot de passe oublié ?",
      "signIn": "Se connecter",
      "signingIn": "Connexion en cours...",
      "accessNote": "Accès réservé au personnel autorisé",
      "invalidCredentials": "Identifiants incorrects. Veuillez réessayer.",
      "usernamePlaceholder": "Nom d'utilisateur",
      "passwordPlaceholder": "Mot de passe"
    }
  },
  // Nouvelles sections de la page d'accueil
  "stats": {
    "title": "Nos statistiques",
    "youth_reached": "Jeunes touchés",
    "youth_reached_desc": "Jeunes qui ont participé aux différentes activités du DNC",
    "youth_beneficiaries": "Jeunes bénéficiaires",
    "youth_beneficiaries_desc": "Participants actifs ayant suivi le programme complet du DNC",
    "positive_outcomes": "Sorties positives",
    "positive_outcomes_desc": "Jeunes ayant développé leurs compétences et trouvé une formation, un emploi ou lancé leur projet",
    "partners": "Partenaires",
    "partners_desc": "Organisations et entreprises qui soutiennent notre mission"
  },

  "testimonials": {
    "title": "Ce qu'ils disent de nous",
    "participant": "Participant(e)",
    "mohamed": "Avant de rejoindre le DNC, j'étais perdu et sans direction. Grâce à l'accompagnement personnalisé, j'ai découvert ma passion pour le développement web et j'ai maintenant un emploi stable dans une entreprise technologique.",
    "leila": "Le DNC m'a donné l'opportunité de développer mes compétences en design et communication. Je suis maintenant en formation pour devenir designer UX/UI, un domaine qui me passionne vraiment.",
    "amine": "J'ai eu la chance de participer au programme d'entrepreneuriat du DNC. Aujourd'hui, je gère ma propre petite entreprise et je continue à recevoir du soutien de la communauté DNC.",
    "sarah": "Le DNC a été un tournant dans ma vie. J'ai non seulement acquis des compétences techniques, mais aussi développé ma confiance en moi. Maintenant, je poursuis mes études en informatique à l'université."
  },

  "usertype": {
    "title": "Vous êtes qui ?",
    "youth": "Jeune",
    "youth_desc": "Vous souhaitez développer vos compétences et trouver votre voie",
    "partner": "Partenaire",
    "partner_desc": "Vous voulez collaborer avec nous et soutenir notre mission",
    "parent": "Parent",
    "parent_desc": "Vous cherchez à comprendre notre approche pédagogique",
    "signup": "S'inscrire",
    "discover": "Découvrir",
    "learn_more": "En savoir plus"
  },

  // Composants communs
  "common": {
    "loading": "Chargement...",
    "error": "Une erreur s'est produite",
    "retry": "Réessayer",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "readMore": "Lire plus",
    "showMore": "Voir plus",
    "showLess": "Voir moins",
    "all": "Tous",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "search": "Rechercher",
    "filter": "Filtrer",
    "notFound": "Page non trouvée",
    "notFoundMessage": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "goHome": "Retour à l'accueil",
    "more": "Voir plus",
    "less": "Voir moins",
    "darkMode": "Mode sombre",
    "lightMode": "Mode clair"
  },
  
 
  // Footer
},
"common": {
    "loading": "Chargement...",
    "error": "Une erreur s'est produite",
    "retry": "Réessayer",
    "back": "Retour",
    "next": "Suivant",
    "previous": "Précédent",
    "readMore": "Lire plus",
    "showMore": "Voir plus",
    "showLess": "Voir moins",
    "all": "Tous",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "search": "Rechercher",
    "filter": "Filtrer",
    "notFound": "Page non trouvée",
    "notFoundMessage": "La page que vous recherchez n'existe pas ou a été déplacée.",
    "goHome": "Retour à l'accueil",
    "more": "Voir plus",
    "less": "Voir moins",
    "darkMode": "Mode sombre",
    "lightMode": "Mode clair"
  },
  
// Page contact
"contact": {
  "title": "Contactez-nous",
  "subtitle": "Nous sommes à votre écoute pour répondre à vos questions et vous accompagner dans votre parcours",
  "getInTouch": "Nos coordonnées",
  "sendMessage": "Envoyez-nous un message",
  "followUs": "Suivez-nous",
  "viewLargerMap": "Voir la carte en grand",
  "info": {
    "address": {
      "content": "Immeuble Habiba, Rue Jawharat Essahel - Khezama "
    },
    "phone": {
      "content": "56069069 (Sousse) / 51022929 (Kairouan)"
    },
    "email": {
      "content": "dispositifnouvellechance@gmail.com"
    },
    "hours": {
      "content": "Lundi - Vendredi: 9h00 - 17h00"
    }
  },
  "form": {
    "name": "Nom complet",
    "email": "Adresse email",
    "subject": "Sujet",
    "message": "Votre message",
    "send": "Envoyer le message",
    "success": {
      "title": "Message envoyé !",
      "message": "Merci pour votre message. Nous vous répondrons dans les plus brefs délais."
    },
    "error": "Une erreur s'est produite. Veuillez réessayer."
  },
  "locations": {
    "sousse": "Sousse",
    "kairouan": "Kairouan",
    "sousse_address": "Immeuble Habiba, Rue Jawharat Essahel - Khezama - Sousse",
    "kairouan_address": "Rue Tarek Ibn Zied - Kairouan"
  }
},
"footer": {
    "description": "Le Dispositif National Nouvelle Chance (DNC) est un programme d'accompagnement intensif pour les jeunes NEETs, visant à faciliter leur insertion professionnelle.",
    "quickLinks": "Liens rapides",
    "contactUs": "Contactez-nous",
    "address": "123 Rue de l'Avenir, Tunis, Tunisie",
    "phone": "Téléphone",
    "email": "Email",
    "newsletter": "Newsletter",
    "newsletterText": "Inscrivez-vous à notre newsletter pour recevoir les dernières actualités et événements.",
    "emailPlaceholder": "Votre adresse email",
    "subscribe": "S'abonner",
    "rights": "Tous droits réservés."
  }, 
  "notFound": {
    "title": "Page non trouvée",
    "message": "Oups ! La page que vous recherchez semble avoir disparu.",
    "backHome": "Retour à l'accueil"
  }
  
};

